import styled from "styled-components";

export default styled.div`
  height: 100%;

  .auxiliary-menu {
    width: 0px;
    margin-right: 0px;
    overflow: hidden;
    -webkit-transition: 200ms width ease-in-out, 100ms opacity ease-in-out,
      200ms padding-left ease-in-out, 200ms margin-right ease-in-out;

    opacity: 0;
    height: 100%;
    position: relative;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;

    &--open {
      width: 165px;

      -webkit-transition: 200ms width ease-in-out, 400ms opacity ease-in-out,
        200ms padding-left ease-in-out, 200ms margin-right ease-in-out;

      opacity: 1;
    }

    .auxiliary-menu-container {
      width: 165px !important;
      height: 100%;
      overflow: scroll;
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */

      &::-webkit-scrollbar {
        display: none;
      }
    }

    .auxiliary-menu-velo {
      position: absolute;
      width: 100%;
      height: 50px;
      background-color: red;
      z-index: 1000;

      &--superior {
        top: 0;
        left: 0;
        background: rgb(2, 0, 36);
        background: linear-gradient(
          0deg,
          rgba(2, 0, 36, 0) 0%,
          rgba(255, 255, 255, 1) 35%,
          rgba(255, 255, 255, 1) 100%
        );
      }

      &--inferior {
        bottom: 0;
        left: 0;

        background: rgb(2, 0, 36);
        background: linear-gradient(
          180deg,
          rgba(2, 0, 36, 0) 0%,
          rgba(255, 255, 255, 1) 35%,
          rgba(255, 255, 255, 1) 100%
        );
      }
    }
  }
`;
